<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <mat-card-title>
      <h2>Detalle de Menú</h2>
    </mat-card-title>

    <mat-card-content
      *ngIf="isLoading"
      class="d-flex flex-col flex-wrap align-items-center justify-content-center"
      style="padding-bottom: 36px"
    >
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p>Cargando Platos...</p>
    </mat-card-content>
  </mat-card-content>

  <div class="container">
    <mat-card>
      <mat-card-content>
        <form [formGroup]="menuForm">
          <div formGroupName="menu">
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 0.8rem;
              "
            >
              <mat-form-field appearance="outline">
                <mat-label>Nombre</mat-label>
                <input
                  matInput
                  placeholder="Nombre"
                  formControlName="nombre"
                  name="nombre"
                  required
                  [readonly]="isReadOnly"
                />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Descripción</mat-label>
                <input
                  matInput
                  placeholder="Descripción"
                  formControlName="descripcion"
                  name="descripcion"
                  required
                  [readonly]="isReadOnly"
                />
              </mat-form-field>
            </div>

            <div
              style="display: flex; flex-wrap: wrap; justify-content: center"
            >
              <button mat-raised-button color="primary" (click)="updateMenu()">
                {{ this.buttonTitle }}
              </button>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="d-flex justify-content-between">
    <div *ngIf="!isLoading" class="w-100 col-sm-4">
      <button
        mat-button
        mat-flat-button
        mat-raised-button
        color="primary"
        (click)="openDialogAdd()"
      >
        Agregar Plato
      </button>
    </div>
    <div class="col-sm-4 w-100">
      <mat-form-field appearance="outline" class="w-100 hide-hint">
        <input matInput placeholder="Buscar..." (keyup)="applyFilter($event)" />
        <mat-icon matSuffix>
          <i-tabler name="search" class="icon-20"></i-tabler>
        </mat-icon>
      </mat-form-field>
    </div>
  </div>

  <mat-card-content>
    <div *ngIf="dishes && dishes.length > 0">
      <table mat-table [dataSource]="dataSource" class="table-responsive">
        <ng-container matColumnDef="nombrePlato">
          <th mat-header-cell *matHeaderCellDef>Nombre del Plato</th>
          <td mat-cell *matCellDef="let element">{{ element.nombrePlato }}</td>
        </ng-container>

        <ng-container matColumnDef="categoria">
          <th mat-header-cell *matHeaderCellDef>Categoría</th>
          <td mat-cell *matCellDef="let element">{{ element.categoria }}</td>
        </ng-container>

        <ng-container matColumnDef="observaciones">
          <th mat-header-cell *matHeaderCellDef>Observaciones (opcionales)</th>
          <td mat-cell *matCellDef="let element">
            {{ element.observaciones }}
          </td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
          <th mat-header-cell *matHeaderCellDef>Eliminar</th>
          <td mat-cell *matCellDef="let element; let i = index">
            <button mat-icon-button (click)="deletePlato(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div [hidden]="(dishes && dishes.length === 0) || dishes === null">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
